import initSplide from "./initSplide";
import initStickySidebar from "./initStickySidebar";
import initObserveAnimation from "./initObserveAnimation";
import initHmMv from "./initHmMv";
import initProductChillerMaping from "./initProductChillerMaping";
import initProductBoilerMaping from "./initProductBoilerMaping";

export default function initAnimationScript() {
  // Splide
  initSplide();

  // カレントナビ
  initStickySidebar();

  // スクロール連動アニメーション
  initObserveAnimation();

  // 製品ラインアップ比較表
  initProductChillerMaping();
  initProductBoilerMaping();

  // 画面読み込み完了時にクラスを付与 (アニメーション用)
  window.addEventListener("load", () => {
    document.body.classList.add("js-loaded");
  });

  // トップ MV（Three.js）— トップページのみ初期化
  const mvStage = document.querySelector(".js-hm-mv-stage");
  if (mvStage) {
    initHmMv().catch((error) => {
      console.error("[hm-mv] Failed to initialize:", error);
      mvStage.classList.add("is-fallback");
    });
  }
}
